export const navLinksdata = [
  {
    title: "Home",
    link: "/",
  },
  {
    title: "Clips",
    link: "/clips",
  },
  {
    title: "Birthday",
    link: "/birthday",
  },
  {
    title: "Pac-Can",
    link: "/pac-can",
  },
];
